import { Button, Col, Row } from "react-bootstrap";
import React, { Dispatch, SetStateAction, useState, useEffect } from "react";
import { toast } from "react-toastify";
import { TYPE_KE_HOACH_DAO_TAO } from "../../../../quan-ly-khao-sat/Components/danh-sach-ke-hoach/constants/constansKeHoach";
import TableNhanLuc from "./TableNhanLuc";
import LabelRequired from "../../../../component/LabelRequired";
import TextField from "../../../../component/TextField";

interface Props {
  initialValues: any;
  setInitialValues: Dispatch<SetStateAction<any>>;
  dataTrangThietBi: any[];
  setDataTrangThietBi: Dispatch<SetStateAction<any[]>>;
  isView?: boolean;
}

const HoanThanhKyThuat = (props: Props) => {
  const { dataTrangThietBi, setDataTrangThietBi, isView } = props;

  const [tenThuThuat, setTenThuThuat] = useState<string>('');
  const [quanSatSoLuongBN, setQuanSatSoLuongBN] = useState<string>('');
  const [kienTapDoLuongBN, setKienTapDoLuongBN] = useState<string>('');
  const [thDuoiHuongDanGV, setThDuoiHuongDanGV] = useState<string>('');
  const [tuThDuoiGiamSatGV, setTuThDuoiGiamSatGV] = useState<string>('');
  const [editingIndex, setEditingIndex] = useState<number | null>(null);

  const handleAddOrUpdate = () => {
    if (!tenThuThuat || !quanSatSoLuongBN || !kienTapDoLuongBN || !thDuoiHuongDanGV || !tuThDuoiGiamSatGV) {
      toast.warning('Vui lòng điền đầy đủ thông tin');
      return;
    }

    const newItem = {
      tenThuThuat,
      quanSatSoLuongBN,
      kienTapDoLuongBN,
      thDuoiHuongDanGV,
      tuThDuoiGiamSatGV
    };

    if (editingIndex !== null) {
      const updatedList = [...dataTrangThietBi];
      updatedList[editingIndex] = newItem;
      setDataTrangThietBi(updatedList);
      setEditingIndex(null);
      toast.success('Cập nhật thành công');
    } else {
      setDataTrangThietBi([newItem, ...dataTrangThietBi]);
      toast.success('Thêm thành công');
    }

    setTenThuThuat('');
    setQuanSatSoLuongBN('');
    setKienTapDoLuongBN('');
    setThDuoiHuongDanGV('');
    setTuThDuoiGiamSatGV('');
  };

  const handleEdit = (row: any, index: number) => {
    setTenThuThuat(row.tenThuThuat || '');
    setQuanSatSoLuongBN(row.quanSatSoLuongBN || '');
    setKienTapDoLuongBN(row.kienTapDoLuongBN || '');
    setThDuoiHuongDanGV(row.thDuoiHuongDanGV || '');
    setTuThDuoiGiamSatGV(row.tuThDuoiGiamSatGV || '');
    setEditingIndex(index);
  };

  const handleDelete = (index: number) => {
    const updatedList = dataTrangThietBi.filter((_: any, i: number) => i !== index);
    setDataTrangThietBi(updatedList);
    toast.success('Xóa thành công');
  };

  const columnsDkDaoTao = [
    {
      name: "STT",
      field: "",
      headerStyle: { width: 80 },
      cellStyle: { textAlign: "center" },
      render: (row: any, index: number, stt: number) => stt,
    },
    ...(!isView
      ? [
        {
          name: "Thao tác",
          field: "",
          headerStyle: { width: 100 },
          cellStyle: { textAlign: "center", justifyContent: "center" },
          render: (row: any, index: number) => (
            <div className="d-flex justify-content-center">
              <i
                onClick={() => handleEdit(row, index)}
                className="bi bi-pencil-square text-navy cursor-pointer"
                style={{ cursor: 'pointer', marginRight: '10px' }}
              ></i>
              <i
                onClick={() => handleDelete(index)}
                className="bi bi-trash3-fill text-danger cursor-pointer"
                style={{ cursor: 'pointer' }}
              ></i>
            </div>
          ),
        },
      ]
      : []),
    {
      name: "Tên thủ thuật",
      field: "tenThuThuat",
      headerStyle: { minWidth: 200 },
      cellStyle: { textAlign: "left" },
      render: (row: any) => row.tenThuThuat || '',
    },
    {
      name: "Quan sát",
      field: "quanSatSoLuongBN",
      headerStyle: { minWidth: 120 },
      cellStyle: { textAlign: "center" },
      render: (row: any) => row.quanSatSoLuongBN || '',
    },
    {
      name: "TH dưới hướng dẫn của giảng viên",
      field: "thDuoiHuongDanGV",
      headerStyle: { minWidth: 150 },
      cellStyle: { textAlign: "center" },
      render: (row: any) => row.thDuoiHuongDanGV || '',
    },
    {
      name: "Tự TH dưới giám sát của giảng viên",
      field: "tuThDuoiGiamSatGV",
      headerStyle: { minWidth: 150 },
      cellStyle: { textAlign: "center" },
      render: (row: any) => row.tuThDuoiGiamSatGV || '',
    },
    {
      name: "Kiên tập",
      field: "kienTapDoLuongBN",
      headerStyle: { minWidth: 120 },
      cellStyle: { textAlign: "center" },
      render: (row: any) => row.kienTapDoLuongBN || '',
    },
  ];

  return (
    <div className="">
      <div className="spaces mt-2 title">
        <span className="text-title fw-bold fs-5 spaces mb-5 mt-20">
          Chỉ tiêu hoàn thành kỹ thuật
        </span>
      </div>
      <Row>
        <Col lg={2} className="spaces">
          <div className="spaces pt-10">
            <div className="spaces mt-1">
              <LabelRequired className="min-w-100px" label="Tên thủ thuật" />
            </div>
          </div>
        </Col>
        <Col lg={10} className="spaces pt-8">
          <TextField
            name="tenThuThuat"
            type="text"
            onChange={(e: any) => setTenThuThuat(e.target.value)}
            value={tenThuThuat}
            disabled={isView}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col lg={2} className="spaces">
          <div className="spaces pt-10">
            <div className="spaces mt-1">
              <LabelRequired className="min-w-100px" label="Quan sát (số lượng BN)" />
            </div>
          </div>
        </Col>
        <Col lg={4} className="spaces pt-8">
          <TextField
            name="quanSatSoLuongBN"
            type="number"
            onChange={(e: any) => setQuanSatSoLuongBN(e.target.value)}
            value={quanSatSoLuongBN}
            disabled={isView}
          />
        </Col>
        <Col lg={3} className="spaces">
          <div className="spaces pt-10">
            <div className="spaces mt-1">
              <LabelRequired className="min-w-100px" label="TH dưới hướng dẫn của giảng viên (số lượng BN)" />
            </div>
          </div>
        </Col>
        <Col lg={3} className="spaces pt-8">
          <TextField
            name="thDuoiHuongDanGV"
            type="number"
            onChange={(e: any) => setThDuoiHuongDanGV(e.target.value)}
            value={thDuoiHuongDanGV}
            disabled={isView}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col lg={2} className="spaces">
          <div className="spaces pt-10">
            <div className="spaces mt-1">
              <LabelRequired className="min-w-100px" label="Kiên tập độc lập (số lượng BN)" />
            </div>
          </div>
        </Col>
        <Col lg={4} className="spaces pt-8">
          <TextField
            name="kienTapDoLuongBN"
            type="number"
            onChange={(e: any) => setKienTapDoLuongBN(e.target.value)}
            value={kienTapDoLuongBN}
            disabled={isView}
          />
        </Col>
        <Col lg={3} className="spaces">
          <div className="spaces pt-10">
            <div className="spaces mt-1">
              <LabelRequired className="min-w-100px" label="Tự TH dưới giám sát của giảng viên (số lượng BN)" />
            </div>
          </div>
        </Col>
        <Col lg={3} className="spaces pt-8">
          <TextField
            name="tuThDuoiGiamSatGV"
            type="number"
            onChange={(e: any) => setTuThDuoiGiamSatGV(e.target.value)}
            value={tuThDuoiGiamSatGV}
            disabled={isView}
          />
        </Col>
      </Row>
      {!isView && (
        <div className="flex mt-10 spaces items-center">
          <Button
            className="btn-fill spaces min-w-90px btn btn-primary"
            onClick={handleAddOrUpdate}
            type="button"
          >
            <i className="bi bi-plus-lg number-pri fs-3"></i>
            {editingIndex !== null ? 'Cập nhật' : 'Thêm'}
          </Button>
          {editingIndex !== null && (
            <Button
              className="btn-fill spaces min-w-90px btn btn-secondary ml-2"
              onClick={() => {
                setEditingIndex(null);
                setTenThuThuat('');
                setQuanSatSoLuongBN('');
                setKienTapDoLuongBN('');
                setThDuoiHuongDanGV('');
                setTuThDuoiGiamSatGV('');
              }}
              type="button"
            >
              Hủy
            </Button>
          )}
        </div>
      )}
      <TableNhanLuc
        columns={columnsDkDaoTao}
        isView={isView}
        dsItems={dataTrangThietBi ?? []}
      />
    </div>
  );
};

export default HoanThanhKyThuat;